import React, { useState } from 'react';
import styled, { StylesProps, cx } from '../../../lib/styles';
import Typography from '../../../components/presentational/Typography';
import Spacer from '../../../components/presentational/Spacer';
import externalSearchBlockStyles from './ExternalSearchBlock_styles';
import CruiseForm from '../SearchBlock/CruiseForm';

export interface ExternalSearchBlockData {
  type: 'external_cruise_search_block';
  title: string;
}

export interface ExternalSearchBlockProps {
  block: ExternalSearchBlockData;
}

const ExternalSearchBlock = ({ block: { title }, styles }) => {
  return (
    <div
      className={`d-flex flex-column external-search-block ${styles.container}`}
    >
      <Spacer width={1160} space={['m', 'l']}>
        <Spacer space={['s', 'm']}>
          {title ? (
            <div className={`d-flex ${styles.titleText}`}>
              <h1>{title}</h1>
            </div>
          ) : (
            <></>
          )}
        </Spacer>
      </Spacer>
      <Spacer width={1160} space={['m', 'l']}>
        <Spacer space={['s', 'm']}>
          <CruiseForm {...styles} />
        </Spacer>
      </Spacer>
    </div>
  );
};

export default styled(externalSearchBlockStyles)(ExternalSearchBlock);
